/* FocusedTaskErrorBoundaryFallback.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { Stack } from '@atlaskit/primitives';
import FocusedTask from '@atlassian/focused-task';
import { H4 } from '@atlassian/mpac-primitives';
import { ToolsIcon } from '@atlassian/mpac-ui';
import { IntlProvider } from 'react-intl-next';
import { TEST_IDS } from '../constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _5 = "._syaz131l{color:var(--ds-text-subtlest,#626f86)}";
const _4 = "._4cvr1h6o{align-items:center}";
const _3 = "._1e0c1txw{display:flex}";
const _2 = "._4t3i31sa{height:12rem}";
const _ = "._1bsb31sa{width:12rem}";
const errorImageStyles = null;
const contentStyles = null;
export const FocusedTaskErrorBoundaryFallback = _ref => {
  let {
    isOpen,
    onClose
  } = _ref;
  const getErrorContent = () => {
    return /*#__PURE__*/_jsxs(Stack, {
      space: "space.800",
      children: [/*#__PURE__*/_jsx(H4, {
        children: "Error"
      }), /*#__PURE__*/_jsxs(Stack, {
        space: "space.800",
        alignBlock: "center",
        alignInline: "center",
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_, _2]
          }), /*#__PURE__*/_jsx("img", {
            alt: "Error",
            src: ToolsIcon,
            className: ax(["_1bsb31sa _4t3i31sa"])
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_3, _4, _5]
          }), /*#__PURE__*/_jsxs("div", {
            className: ax(["_1e0c1txw _4cvr1h6o _syaz131l"]),
            children: [/*#__PURE__*/_jsx(WarningIcon, {
              primaryColor: "var(--ds-icon-danger, #C9372C)",
              label: ""
            }), /*#__PURE__*/_jsx("span", {
              children: "Try again later."
            })]
          })]
        })]
      })]
    });
  };
  const steps = [{
    id: 'select-a-site-step',
    label: 'Select a site',
    type: 'progress',
    content: getErrorContent(),
    contentSize: 'large'
  }, {
    id: 'review-and-install-step',
    label: 'Review and install',
    type: 'progress',
    content: /*#__PURE__*/_jsx("div", {}),
    contentSize: 'large'
  }];
  return /*#__PURE__*/_jsx(IntlProvider, {
    locale: "en",
    children: /*#__PURE__*/_jsx(FocusedTask, {
      testId: TEST_IDS.TWO_CLICK_APP_INSTALL_ERROR_BOUNDARY,
      currentStep: 0,
      isOpen: isOpen,
      steps: steps,
      onClose: onClose
    })
  });
};